import React, { useState, useEffect } from 'react';

function CariPo({ onSelect, onCancel }) {
  const [poList, setPoList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPo, setFilteredPo] = useState([]);
  const schema = localStorage.getItem('schema');
  
  useEffect(() => {
    const fetchPo = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=cari_po&schema=${schema}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setPoList(data);
        setFilteredPo(data);
      } catch (error) {
        console.error('Error fetching PO:', error);
      }
    };
    fetchPo();
  }, []);

  useEffect(() => {
    const filtered = poList.filter((po) =>
      [po.NO_PO, po.NAMAREKANAN, po.KOTA_ASAL, po.KOTA_TUJUAN, po.SUBCITY, po.JNS_KENDARAAN, po.JNS_MUATAN, po.NO_TRANSAKSI]
        .some(val => val && val.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFilteredPo(filtered);
  }, [searchTerm, poList]);

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Pilih Purchase Order</h2>

      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Cari PO, rekanan, kota, atau muatan..."
        style={styles.searchInput}
      />

      <div style={{ overflowX: 'auto' }}>
        <table style={{ ...styles.table, border: '1px solid #ccc' }}>
          <thead>
            <tr>
              {[
                'No. PO', 'Tgl PO', 'Rekanan', 'Asal', 'Tujuan', 
                'Subcity', 'Jns Kend', 'Jns Muatan', 'Aksi','No Transaksi'
              ].map((header, idx) => (
                <th key={idx} style={styles.th}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredPo.map((po, index) => (
              <tr key={index}>
                <td style={styles.td}>{po.NO_PO}</td>
                <td style={styles.td}>{po.TGL_PO}</td>
                <td style={styles.td}>{po.NAMAREKANAN}</td>
                <td style={styles.td}>{po.KOTA_ASAL}</td>
                <td style={styles.td}>{po.KOTA_TUJUAN}</td>
                <td style={styles.td}>{po.SUBCITY}</td>
                <td style={styles.td}>{po.JNS_KENDARAAN}</td>
                <td style={styles.td}>{po.JNS_MUATAN}</td>
                <td style={styles.td}>{po.NO_TRANSAKSI}</td>
                <td style={{ ...styles.td, textAlign: 'center' }}>
                  <button style={styles.selectButton} onClick={() => onSelect(po)}>
                    Pilih
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button style={styles.cancelButton} onClick={onCancel}>Batal</button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1000px',
    margin: '40px auto',
    padding: '20px',
    backgroundColor: '#ffffff',
    border: '1px solid #ccc',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    textAlign: 'center',
    marginBottom: '20px',
    color: '#333',
  },
  searchInput: {
    width: '100%',
    padding: '10px',
    marginBottom: '20px',
    borderRadius: '6px',
    border: '1px solid #bbb',
    fontSize: '14px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    border: '1px solid #ccc',
    padding: '8px',
    backgroundColor: '#f2f2f2',
    textAlign: 'left',
  },
  td: {
    border: '1px solid #ccc',
    padding: '8px',
  },
  selectButton: {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  cancelButton: {
    backgroundColor: '#e53935',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default CariPo;
